import RestClient from './../../service/rest-client';
import {Signal} from 'signals';
import moment from 'moment';
import numeral from 'numeral';
import _ from 'underscore';
import utils from './../../component/utils/utils';

class Service {

    event = {
        onFetchRevenueStatsPerDay: new Signal(),
        onFetchRevenueStatsByCountry: new Signal(),
        onFetchRevenueStatsBySource: new Signal(),
        onFetchRevenueStatsBySubject: new Signal(),
        onFetchRevenueSeriesChartData: new Signal(),
        onFetchAverageRevenueShipmentPerDayChartData: new Signal(),
        onFetchRevenuePerDayChartData: new Signal(),
        onFetchRevenueSeriesByMonthChartData: new Signal(),
    };

    fetchRevenueStatsPerDay(intervalDates, typeOfRequest) {
        intervalDates = intervalDates || 1;
        typeOfRequest = typeOfRequest || 'table';

       RestClient.isSessionActive();
        var queryParams = [`interval_days=${ intervalDates }`];

          var urlRequestTemplate = "/reporting/revenuestats/perday?" + queryParams.join("&");

           return RestClient.getRequest(urlRequestTemplate,"").then((data) => {
               var page = data.page_number;
               var pageSize = data.page_size,
                   offset = (page - 1) * pageSize;
               var pagingMetadata = {
                   page: data.page_number,
                   startIndex: offset + 1,
                   endIndex: offset + pageSize,
                   totalCount: data.total_count,
                   pageCount: Math.max(Math.ceil(data.total_count / pageSize), 1)//Always 1 page, even if 0 results
               };
                   data.pagingMetadata = pagingMetadata;
                   data.results = this.parseRevenueStatsPerDay(data.results);
                   this.event.onFetchRevenueStatsPerDay.dispatch(data);
           }).catch((error) => {
               console.log("Error: " + error);
           });
    }

    parseRevenueStatsPerDay(resultData) {
        var parsedArray = resultData.map(function(dataItem) {
            var parsedObject = {};
            parsedObject.id = dataItem.id;
            parsedObject.date = moment(dataItem.date).format("L");
            parsedObject.fullAmount = numeral(dataItem.fullAmount).format('$0,0.00');

            return parsedObject;
        });
        return parsedArray;
    }

    // start histogram by country
    fetchRevenueStatsByCountry(intervalDays) {
        RestClient.isSessionActive();
        var queryParams = [`interval_days=${ intervalDays }`];
        var urlRequestTemplate = "/reporting/revenuestats/bycountry?" + queryParams.join("&");

        return RestClient.getRequest(urlRequestTemplate,"").then( (data) => {
            var chartData = this.parseRevenueDataByCountry(data.results);
            this.event.onFetchRevenueStatsByCountry.dispatch(chartData);
        }).catch((error) => {
            console.log("Error: " + error);
        });
    }

    parseRevenueDataByCountry(resultData) {
        var chartData = {
            categoryList : [],
            seriesDataList: []
        };

        resultData.forEach(function(dataItem) {
            chartData.categoryList.push(dataItem.countryName);
            chartData.seriesDataList.push(dataItem.fullAmount);
        });

        return chartData;
    }
    // end histogram by country

    // start histogram by source
    fetchRevenueStatsBySource(intervalDays) {
        RestClient.isSessionActive();
        var queryParams = [`interval_days=${ intervalDays }`];

        var urlRequestTemplate = "/reporting/revenuestats/bysource?" + queryParams.join("&");

        return RestClient.getRequest(urlRequestTemplate,"").then( (data) => {
            var chartData = this.parseRevenueDataBySource(data.results);
            this.event.onFetchRevenueStatsBySource.dispatch(chartData);
        }).catch((error) => {
            console.log("Error: " + error);
        });
    }

    parseRevenueDataBySource(resultData) {
        var chartData = {
            categoryList : [],
            seriesDataList: []
        };

        resultData.forEach(function(dataItem) {
            chartData.categoryList.push(dataItem.utmSource.replace(/first:|last:/gi, ''));
            chartData.seriesDataList.push(dataItem.fullAmount);
        });

        return chartData;
    }
    // end histogram by source

    // start histogram by subject
    fetchRevenueStatsBySubject(intervalDays) {
        RestClient.isSessionActive();
        var queryParams = [`interval_days=${ intervalDays }`];

        var urlRequestTemplate = "/reporting/revenuestats/bysubject?" + queryParams.join("&");

        return RestClient.getRequest(urlRequestTemplate,"").then( (data) => {
            var chartData = this.parseRevenueDataBySubject(data.results);
            this.event.onFetchRevenueStatsBySubject.dispatch(chartData);
        }).catch((error) => {
            console.log("Error: " + error);
        });
    }

    parseRevenueDataBySubject(resultData) {
        var chartData = {
            categoryList : [],
            seriesDataList1: [],
            seriesDataList2: [],
            seriesDataList3: []
        };

        resultData.forEach(function(dataItem) {
            chartData.categoryList.push(moment(dataItem.date).format("L"));
            chartData.seriesDataList1.push(dataItem.shipmentAmount);
            //chartData.seriesDataList2.push(dataItem.shipmentAmount - Math.floor((Math.random() * 500) + 1));
            //chartData.seriesDataList3.push(dataItem.shipmentAmount - Math.floor((Math.random() * 700) + 1));
            chartData.seriesDataList2.push(dataItem.orderAmount);
            chartData.seriesDataList3.push(dataItem.succAmount);
        });

        return chartData;
    }
    // end histogram by subject

    // new repeat and total series of revenue
    fetchRevenueSeriesByDay(intervalDates) {
        intervalDates = intervalDates || 1;

        RestClient.isSessionActive();
        var queryParams = [`interval_days=${ intervalDates }`];

        var urlRequestTemplate = "/reporting/revenuestats/seriesbyday?" + queryParams.join("&");

        return RestClient.getRequest(urlRequestTemplate,"").then((data) => {
            data.chartData = this.parseRequestDataSeriesByDay(data.results[0]);
            this.event.onFetchRevenueSeriesChartData.dispatch(data);
        }).catch((error) => {
            console.log("Error: " + error);
        });
    }

    parseRequestDataSeriesByDay(resultData) {
        var chartData = {
            categoryList : [],
            seriesDataList1: [],
            seriesDataList2: [],
            seriesDataList3: []
        };

        resultData.totalRevenueSeries.forEach(function(dataItem) {
            chartData.categoryList.push(moment(dataItem.date).format(utils.shortDateFormat));
            chartData.seriesDataList1.push(dataItem.totalAmountSum);
        });

        resultData.newRevenueSeries.forEach(function(dataItem) {
            chartData.seriesDataList2.push(dataItem.newAmountSum);
        });

        resultData.repeatRevenueSeries.forEach(function(dataItem) {
            chartData.seriesDataList3.push(dataItem.repeatAmountSum);
        });

        var mergedList = _.zip(chartData.seriesDataList1, chartData.seriesDataList2);
        chartData.seriesDataList3 = _.map(mergedList, function(pair) {
            var totalAmount = pair[0];
            var newAmount = pair[1];
            var repeatAmount = totalAmount - newAmount;
            repeatAmount = Number(numeral(repeatAmount).format('0[.]00'));
            return repeatAmount;
        });

        return chartData;
    }

    // start block average revenue shipment
    fetchAverageRevenueShipmentStats(intervalDays) {
        RestClient.isSessionActive();
        var queryParams = [`interval_days=${ intervalDays }`];

        var urlRequestTemplate = "/reporting/revenuestats/averagerevenueperday?" + queryParams.join("&");

        return RestClient.getRequest(urlRequestTemplate,"").then( (data) => {
            data.chartData = this.parseAveragerevenueShipmentData(data.results);
            this.event.onFetchAverageRevenueShipmentPerDayChartData.dispatch(data);
        }).catch((error) => {
            console.log("Error: " + error);
        });
    }

    // start block average revenue shipment
    fetchRevenueStatsByDay(intervalDays) {
        RestClient.isSessionActive();
        var queryParams = [`interval_days=${ intervalDays }`];

        var urlRequestTemplate = "/reporting/revenuestats/perday?" + queryParams.join("&");

        return RestClient.getRequest(urlRequestTemplate,"").then( (data) => {
            data.chartData = this.parseRevenueDataPerDay(data.results);
            this.event.onFetchRevenuePerDayChartData.dispatch(data);
        }).catch((error) => {
            console.log("Error: " + error);
        });
    }

    parseAveragerevenueShipmentData(resultData) {
        var chartData = {
            categoryList : [],
            seriesDataList1: [],
        };

        resultData.forEach(function(dataItem) {
            chartData.categoryList.push(moment(dataItem.date).format(utils.shortDateFormat));
            chartData.seriesDataList1.push(dataItem.averageAmountPerShipment);
        });

        return chartData;
    }

    parseRevenueDataPerDay(resultData) {
        var chartData = {
            categoryList : [],
            seriesDataList1: [],
        };

        resultData.forEach(function(dataItem) {
            chartData.categoryList.push(moment(dataItem.date).format(utils.shortDateFormat));
            chartData.seriesDataList1.push(dataItem.fullAmount);
        });

        return chartData;
    }

    fetchRevenueSeriesByMonth(intervalDates) {
        intervalDates = intervalDates || 1;

        RestClient.isSessionActive();
        var queryParams = [`interval_days=${ intervalDates }`];

        var urlRequestTemplate = "/reporting/revenuestats/seriesbyday?" + queryParams.join("&");

        return RestClient.getRequest(urlRequestTemplate,"").then((data) => {
            data.chartData = this.parseRequestDataSeriesByMonth(data.results[0]);
            this.event.onFetchRevenueSeriesByMonthChartData.dispatch(data);
        }).catch((error) => {
            console.log("Error: " + error);
        });
    }

    parseRequestDataSeriesByMonth(resultData) {
        var chartData = {
            categoryListByMonth : [],
            seriesDataListByMonth1: [],
            seriesDataListByMonth2: [],
            seriesDataListByMonth3: []
        };

        resultData.totalRevenueSeries.forEach(function(dataItem) {
            chartData.categoryListByMonth.push(moment(dataItem.date).format("MM/YYYY"));
            chartData.seriesDataListByMonth1.push(dataItem.totalAmountSum);
        });

        resultData.newRevenueSeries.forEach(function(dataItem) {
            chartData.seriesDataListByMonth2.push(dataItem.newAmountSum);
        });

        resultData.repeatRevenueSeries.forEach(function(dataItem) {
            chartData.seriesDataListByMonth3.push(dataItem.repeatAmountSum);
        });

        var mergedList = _.zip(chartData.seriesDataListByMonth1, chartData.seriesDataListByMonth2);
        chartData.seriesDataListByMonth3 = _.map(mergedList, function(pair) {
            var totalAmount = pair[0];
            var newAmount = pair[1];
            var repeatAmount = totalAmount - newAmount;
            repeatAmount = Number(numeral(repeatAmount).format('0[.]00'));
            return repeatAmount;
        });

        return chartData;
    }

} export default new Service();